export default {
  eyebrow: 'Portal partnera',
  title: 'Branding',
  description: 'Wygląd portalu white-label i strony logowania.',
  page: {
    read_only_notice: 'Tylko do odczytu. Kliknij Edytuj, aby zmienić wartość.',
    editing_notice: 'Edycja — zmiany są widoczne dla zespołu i klientów.',
  },
  branding: {
    scope_hint: 'Dotyczy portalu white-label i strony logowania — nie witryn restauracji, które mają własny branding.',
    upload: 'Prześlij logo',
    logo: {
      label: 'Logo',
      hint: 'Wyświetlane na powierzchniach white-label.',
    },
    circle_logo: {
      label: 'Favicon / logo okrągłe',
      hint: 'Kwadratowe logo używane jako favicon i awatar. Opcjonalne — można usunąć.',
    },
    splash_image: {
      label: 'Obraz strony logowania',
      hint: 'Wyświetlany na stronie logowania white-label. Zalecane: co najmniej 1200 px szerokości. Opcjonalne — można usunąć.',
    },
    footer_note: 'Więcej opcji brandingu (kolory dodatkowe) pojawi się wkrótce.',
  },
  form: {
    primary_color: {
      label: 'Główny kolor marki',
      hint: 'Motyw portalu partnera i strony logowania.',
    },
    dashboard_subdomain: {
      label: 'Slug logowania partnera',
      hint: 'Slug małymi literami — identyfikuje markę w linku logowania zespołu (?partner=…).',
      placeholder: 'nazwa-partnera',
    },
    login_url: {
      label: 'Link logowania zespołu',
      hint: 'Udostępnij ten link zespołowi — otwiera stronę logowania z Twoim brandingiem.',
    },
    file: {
      label: 'Obraz',
    },
  },
  login_url_warning: {
    title: 'Zmienić link logowania zespołu?',
    description:
      'Link logowania zespołu zmieni się na {{url}}. Od teraz udostępniaj nowy link — stary nie będzie już pokazywał Twojej marki.',
    description_no_url:
      'Link logowania zespołu zmieni się. Od teraz udostępniaj nowy link — stary nie będzie już pokazywał Twojej marki.',
  },
  login_url_changed: {
    title: 'Link logowania zespołu zmieniony',
    description:
      'Twój zespół loguje się teraz pod adresem {{url}}. Zapisz nowy link w zakładkach i udostępnij go zespołowi.',
  },
  buttons: {
    edit: 'Edytuj',
    cancel: 'Anuluj',
    save: 'Zapisz',
  },
  toasts: {
    load_error: 'Nie można załadować brandingu.',
    failed_to_save_changes: 'Nie udało się zapisać zmian',
    changes_got_saved: 'Zmiany zostały zapisane',
    logo_uploaded: 'Logo przesłane',
    logo_upload_failed: 'Nie udało się przesłać logo',
    logo_removed: 'Logo usunięte',
    logo_remove_failed: 'Nie udało się usunąć logo',
    file_too_large: 'Plik jest za duży. Maksymalny rozmiar to {{max}} MB.',
    image_too_narrow: 'Obraz strony logowania musi mieć co najmniej {{min}} px szerokości.',
  },
};
